<template>
    <div class="calendar-pager" 
        :data-date="date"
        :data-timezone="timezone"
        :data-obj="dateObj"
    >
        <span v-if="Boolean(prev)"
            @click="doButton(prev)"
            title="Previous"
        >
            <CaretLeftFill class="calendar-pager-button" />
        </span>
        <CaretLeft v-else 
            class="calendar-pager-button-disabled" 
        />

        <div class="calendar-pager-date">
            <div class="calendar-pager-line1">{{page.line1}}</div>
            <div class="calendar-pager-line2">{{page.line2}}</div>
        </div>

        <span v-if="Boolean(next)"
            @click="doButton(next)"
            title="Next"
        >
            <CaretRightFill class="calendar-pager-button" />
        </span>
        <CaretRight v-else
            class="calendar-pager-button-disabled" 
        />
            
    </div>
</template>
<script>
import { findPreviousDateKey, findNextDateKey, firstOfWeekObj, lastOfWeekObj, firstOfMonthObj, lastOfMonthObj, keyToLocalTime} from '@/utils/DateTime';
import {dateToKey} from '@/utils/Sort';
import CaretLeft from '@/components/icons/CaretLeft';
import CaretRight from '@/components/icons/CaretRight';
import CaretLeftFill from '@/components/icons/CaretLeftFill';
import CaretRightFill from '@/components/icons/CaretRightFill';

import { ROUTES } from "./config";

/*
const findPrev = (active, strDate) => {
    let i = active.indexOf(strDate);
    console.log("findPrev:", i);
    if (i > 0) { return active[i - 1]; }
    return null;
};
const findNext = (active, strDate) => {
    let i = active.indexOf(strDate);
    console.log("findNext:", i);
    if ( 
        (i >= 0) &&
        (i < active.length - 1)
    ) { return active[i]; }
    return null;
};
*/

export default {
    name: "CalendarPager",
    props: {
        active: { type: Array, required: true},
//        prev: {type: String, required: false},
//        next: {type: String, required: false},
        date: {type: String, required: true},
        timezone: {type: String, required: true}
//        date: {type: Date, required: true},
    },
    components: {
        CaretLeft,
        CaretRight,
        CaretLeftFill,
        CaretRightFill,
    },
    methods: {
        doButton(date) {
            this.$emit('page', date);
        },
    },
    computed: {
        parts() {
            // Calculate the dateObj, start, end strings for the current route
            let parts = {
                // dateObj: new Date(this.date),
                dateObj: keyToLocalTime(this.date),
                // dateObj: dateForTimezone(this.date, this.timezone),
                start: null,
                end: null,
                prev: null,
                next: null
            };
            
            switch (this.$route.name) {
                case ROUTES.DAY:
                    //parts.dateObj = new Date(this.date);
                    parts.prev = findPreviousDateKey(this.active, this.date);
                    parts.next = findNextDateKey(this.active, this.date);
                    break;
                case ROUTES.WEEK:
                    parts.start = firstOfWeekObj(this.date);
                    parts.end = lastOfWeekObj(this.date);
                    parts.prev = findPreviousDateKey(this.active, dateToKey(parts.start));
                    parts.next = findNextDateKey(this.active, dateToKey(parts.end));
                    break;
                case ROUTES.MONTH:
                    parts.start = firstOfMonthObj(this.date);
                    parts.end = lastOfMonthObj(this.date);
                    parts.prev = findPreviousDateKey(this.active, dateToKey(parts.start));
                    parts.next = findNextDateKey(this.active, dateToKey(parts.end));
                    break;
            }

            return parts;
        },
        prev() { return this.parts.prev; },
        next() { return this.parts.next; },
        dateObj() { return this.parts.dateObj; },
        page() {
            let page = {};
            switch (this.$route.name) {
                case ROUTES.DAY:
                    // Tuesday
                    // 1 January 2025
                    page.line1 = new Intl.DateTimeFormat(navigator.language, {
                        weekday: 'long',
                    }).format(this.dateObj);
                    page.line2 = new Intl.DateTimeFormat(navigator.language, {
                        month: 'long', year: 'numeric',
                        day: 'numeric'
                    }).format(this.dateObj);
                    break;

                case ROUTES.WEEK: {
                    // 1 - 6
                    // January 2025
                    // OR
                    // 29 Jan - 4 Dec
                    // 2025
                    let start = new Date(this.dateObj);
                    start.setDate(start.getDate() - start.getDay());
                    let end = new Date(start);
                    end.setDate(end.getDate()+6);
                    // Compare start/end months, so that we know which format to use
                    if (start.getMonth() == end.getMonth()) {
                        page.line1 = `${start.getDate()} - ${end.getDate()}`;
                        page.line2 = new Intl.DateTimeFormat(navigator.language, {
                            month: 'long', year: 'numeric',
                        }).format(start);
                    } else {
                        let str1 = new Intl.DateTimeFormat(navigator.language, {
                            month: 'short',
                            day: 'numeric'
                        }).format(start);
                        let str2 = new Intl.DateTimeFormat(navigator.language, {
                            month: 'short',
                            day: 'numeric'
                        }).format(end);
                        page.line1 = `${str1} - ${str2}`;

                        if (start.getFullYear() == end.getFullYear()) {
                            page.line2 = start.getFullYear();
                        } else {
                            page.line2 = `${start.getFullYear()} - ${end.getFullYear()}`;
                        }
                    }                  
                    break;
                }
                case ROUTES.MONTH:
                    // January
                    // 2025
                    page.line1 = new Intl.DateTimeFormat(navigator.language, {
                        month: 'long', 
                    }).format(this.dateObj);
                    page.line2 = new Intl.DateTimeFormat(navigator.language, {
                        year: 'numeric',
                    }).format(this.dateObj);
                    break;
            }
            return page;
        }
    },
}
</script>
<style>
.calendar-pager {
    display: flex;
    font-size: 12px;
    line-height: 14px;
    gap: 0; /* Pad the buttons instead, to increase the clickable area. */
    align-items: center;
    text-align: center;
}
.calendar-pager-date {
    min-width: 100px;
}
.calendar-pager-button {
    cursor: pointer;
}
.calendar-pager-button-disabled {
    color: #bbb;
}
.calendar-pager-button,
.calendar-pager-button-disabled {
    min-width: 20px;
    min-height: 20px;
    padding: 0 5px; 
}

.calendar-pager-line1 {
    font-weight: bold;
}
</style>